import { CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { createPortal } from "react-dom";
import useNumberFormatter from "../../../hooks/useNumberFormatter";
import { useTutorialContext } from "../TutorialContext";

export default function MobileGlobalMenu() {
    const { tutorials, activeStep } = useTutorialContext();
    const formatter = useNumberFormatter();

    const progress = useMemo(() => {
        return Number(
            (
                (tutorials.indexOf(
                    tutorials.find((s) => s.step === activeStep)
                ) /
                    (tutorials.length - 1)) *
                100
            ).toFixed(0)
        );
    }, [tutorials, activeStep]);

    return createPortal(
        <Paper
            sx={{
                margin: 0,
                position: "fixed",
                bottom: "20px",
                right: "50%",
                transform: "translateX(50%)",
                zIndex: 100000,
                boxSizing: "border-box",
                backgroundColor: "primary.main",
                border: "none",
                padding: 1,
            }}
        >
            <Stack sx={{ height: "100%" }} alignItems="center">
                <Stack
                    className="progress-bar"
                    alignItems="center"
                    sx={{ position: "relative" }}
                >
                    <CircularProgress
                        size={80}
                        value={progress}
                        variant="determinate"
                        color="error"
                    />

                    <Typography
                        variant="body1"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                        }}
                    >
                        پیشرفت شما:{formatter.format(progress)}%
                    </Typography>
                </Stack>
            </Stack>
        </Paper>,
        document.body
    );
}
